// TODO - add to drone variables
export const API_URL = process.env.REACT_APP_API_URL;

export const LS_AUTH_KEY = process.env.REACT_APP_LS_AUTH_KEY;
